import { loadAvailableLocalesService } from 'services';

import { availableLocalesStore } from 'stores';

export const loadAvailableLocales = async () => {
  const locales = await loadAvailableLocalesService.loadLocales();
  availableLocalesStore.set(locales);
};
